// removed by extract-text-webpack-plugin
module.exports = {"next-wrap":"next-wrap___1AGfj line-top____1pk6","next-container":"next-container___UT20z container___mp8vb","next-container-inner":"next-container-inner___3_Ti9 container-inner___1ne89","next":"next___crcRE center___2iqBf","next-left":"next-left___2589Y","next-right":"next-right___3kJhq","label":"label___1asGS h5___l1yk7","label-left":"label-left___1GJCP label___1asGS h5___l1yk7","label-right":"label-right___Hcnw2 label___1asGS h5___l1yk7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FundNext/FundNext.css
// module id = 913
// module chunks = 0